import Research from './research'
export default Research
